import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetPartnersQuery } from "../../../../store/api/sellWithUsApiSlice";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { IPartner } from "../../interfaces";

export default function OurPartners() {
  const { t, i18n } = useTranslation(["sellWithUs"]);
  const theme = useTheme();
  const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down(1200));
  const isRTL = i18n.dir() === "rtl";

  const { data: fetchedPartners } = useGetPartnersQuery(i18n.language);
  const [partners, setPartners] = useState<IPartner[]>([]);

  useEffect(() => {
    if (fetchedPartners) {
      setPartners(
        fetchedPartners.data.length <= 6
          ? fetchedPartners.data
          : fetchedPartners.data.slice(0, 6)
      );
    }
  }, [fetchedPartners]);

  if (partners.length === 0) {
    return <></>;
  }
  return (
    <Box
      sx={{
        mt: isTabletOrSmaller ? "30px" : "110px",
        mb: isTabletOrSmaller ? 0 : "50px",
      }}
    >
      {/* Title */}
      <Typography
        variant="h2"
        sx={{
          textAlign: "center",
          mb: isTabletOrSmaller ? "15px" : "50px",
          textTransform: "uppercase",
          fontSize: isTabletOrSmaller ? "24px" : "36px",
          fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
          fontWeight: 600,
          mt: "70px",
        }}
      >
        {t("partners")}
      </Typography>

      {/* Partners Display */}
      {isTabletOrSmaller ? (
        <Swiper
          allowTouchMove={true}
          loop={true}
          slidesPerView={1}
          speed={1000}
          autoplay={{
            delay: 2000,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          style={
            {
              paddingBottom: "40px",
              "--swiper-pagination-bullet-size": "8px",
              "--swiper-pagination-bullet-inactive-color":
                "rgba(3, 74, 115, 0.59)",
              "--swiper-pagination-color": "rgba(3, 74, 115, 1)",
              "--swiper-pagination-bullet-inactive-opacity": "1",
              "--swiper-pagination-bullet-horizontal-gap": "6px",
            } as React.CSSProperties
          }
        >
          {partners.map((partner, i) => (
            <SwiperSlide key={i}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  color: "rgba(255, 255, 255, 1)",
                  gap: "10px",
                }}
              >
                <img
                  src={partner?.companyLogo?.url}
                  alt={`Partner ${i + 1}`}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </Swiper>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mx: "20px",
            gap: "40px",
          }}
        >
          {partners?.map((partner, index) => (
            <Box
              key={index}
              sx={{
                width: "150px",
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                "&:not(:last-child)::after": {
                  content: '""',
                  position: "absolute",
                  right: "-20px",
                  width: "1px",
                  height: "100px",
                  bgcolor: "#0000001F",
                },
              }}
            >
              <img
                src={partner?.companyLogo?.url}
                alt={`Partner ${index + 1}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
